import ReactMarkdown from "react-markdown";

interface BlogMarkdownViewerProps {
  content: string;
  className?: string;
}

export function BlogMarkdownViewer({ content, className }: BlogMarkdownViewerProps) {
  if (!content) {
    return null;
  }

  return (
    <article className={`prose prose-neutral dark:prose-invert max-w-none ${className ?? ""}`}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </article>
  );
}
